import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { AddressIcon } from '@jsmdg/yoshi';
import { type ProductDetailContext } from '../../types/types';

const Address = () => {
    const { tenantConfig } = useFragmentContext<ProductDetailContext>();
    return (
        <div className="d-flex mt-2x">
            <AddressIcon className="mr-1x flex-shrink-0" />
            <div>
                <div>
                    <span className="d-sm-block">{tenantConfig.brandDisplayName} GmbH</span>
                </div>
                <div>
                    <span className="d-sm-block">{tenantConfig.contactInfo.address.street}</span>
                </div>
                <div>
                    <span className="d-sm-block">
                        {tenantConfig.contactInfo.address.zipCode}{' '}
                        {tenantConfig.contactInfo.address.city}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Address;
